import { all, call, put, takeEvery } from "redux-saga/effects";
import * as customerActions from "../slices/customerSlice";
import customerApis from "src/api/customer";
import { common } from "src/types";
import { constants } from "src/constants/common";

function* getCustomersListSaga({
  payload,
}: ReturnType<typeof customerActions.getCustomersListRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      customerApis.getCustomersList,
      payload
    );
    yield put(customerActions.getCustomersListSuccess(response));
  } catch (error) {
    yield put(
      customerActions.getCustomersListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* createCustomerSaga({
  payload,
}: ReturnType<typeof customerActions.createCustomerRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      customerApis.createCustomer,
      payload
    );
    yield put(customerActions.createCustomerSuccess(response?.data));
  } catch (error) {
    yield put(
      customerActions.createCustomerError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* customerSaga() {
  yield all([
    takeEvery(customerActions.getCustomersListRequest, getCustomersListSaga),
    takeEvery(customerActions.createCustomerRequest, createCustomerSaga),
  ]);
}
